import React from 'react';

import { Heading } from '../../components';

export type AuthHeaderProps = {
  heading: string;
  helpText?: string;
};

export const AuthHeader = ({ heading, helpText }: AuthHeaderProps) => {
  return (
    <div className="flex items-start mb-6">
      <div className="flex flex-col">
        <Heading className="mb-3">{heading}</Heading>
        {helpText && <p>{helpText}</p>}
      </div>
    </div>
  );
};
